








import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { LoadingState } from '@/types';
import Overlay from '@/components/Overlay.vue';

@Component({
  components: {
    Overlay,
  },
})
export default class Spinner extends Vue {
  @Getter private loading!: LoadingState;
  @Prop({ default: false }) private forceLoading!: boolean;
  @Prop({ default: true }) private fullScreen!: boolean;
}
